var map = {
	"./add.svg": "./src/icons/svg/add.svg",
	"./address.svg": "./src/icons/svg/address.svg",
	"./aiicon.svg": "./src/icons/svg/aiicon.svg",
	"./arrow.svg": "./src/icons/svg/arrow.svg",
	"./bill.svg": "./src/icons/svg/bill.svg",
	"./cellClick.svg": "./src/icons/svg/cellClick.svg",
	"./claerance.svg": "./src/icons/svg/claerance.svg",
	"./close.svg": "./src/icons/svg/close.svg",
	"./closeEye.svg": "./src/icons/svg/closeEye.svg",
	"./company.svg": "./src/icons/svg/company.svg",
	"./const.svg": "./src/icons/svg/const.svg",
	"./copy.svg": "./src/icons/svg/copy.svg",
	"./deleteRow.svg": "./src/icons/svg/deleteRow.svg",
	"./detail-bill.svg": "./src/icons/svg/detail-bill.svg",
	"./detail.svg": "./src/icons/svg/detail.svg",
	"./doubleClick.svg": "./src/icons/svg/doubleClick.svg",
	"./download.svg": "./src/icons/svg/download.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./exempt.svg": "./src/icons/svg/exempt.svg",
	"./file-link.svg": "./src/icons/svg/file-link.svg",
	"./filter.svg": "./src/icons/svg/filter.svg",
	"./folder.svg": "./src/icons/svg/folder.svg",
	"./gj-express.svg": "./src/icons/svg/gj-express.svg",
	"./gn-express.svg": "./src/icons/svg/gn-express.svg",
	"./gsyh.svg": "./src/icons/svg/gsyh.svg",
	"./hfyh.svg": "./src/icons/svg/hfyh.svg",
	"./home-tab.svg": "./src/icons/svg/home-tab.svg",
	"./home.svg": "./src/icons/svg/home.svg",
	"./hqyh.svg": "./src/icons/svg/hqyh.svg",
	"./jsyh.svg": "./src/icons/svg/jsyh.svg",
	"./jtyh.svg": "./src/icons/svg/jtyh.svg",
	"./kapai.svg": "./src/icons/svg/kapai.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./log.svg": "./src/icons/svg/log.svg",
	"./logo.svg": "./src/icons/svg/logo.svg",
	"./menu-close.svg": "./src/icons/svg/menu-close.svg",
	"./menu-open.svg": "./src/icons/svg/menu-open.svg",
	"./merge.svg": "./src/icons/svg/merge.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./mgyh.svg": "./src/icons/svg/mgyh.svg",
	"./move.svg": "./src/icons/svg/move.svg",
	"./not-edit.svg": "./src/icons/svg/not-edit.svg",
	"./num-1.svg": "./src/icons/svg/num-1.svg",
	"./num-2.svg": "./src/icons/svg/num-2.svg",
	"./nyyh.svg": "./src/icons/svg/nyyh.svg",
	"./one.svg": "./src/icons/svg/one.svg",
	"./openEye.svg": "./src/icons/svg/openEye.svg",
	"./order.svg": "./src/icons/svg/order.svg",
	"./other.svg": "./src/icons/svg/other.svg",
	"./panel-icon.svg": "./src/icons/svg/panel-icon.svg",
	"./panel-icon1.svg": "./src/icons/svg/panel-icon1.svg",
	"./panelTitle-icon.svg": "./src/icons/svg/panelTitle-icon.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./plane.svg": "./src/icons/svg/plane.svg",
	"./price-detail.svg": "./src/icons/svg/price-detail.svg",
	"./print.svg": "./src/icons/svg/print.svg",
	"./push.svg": "./src/icons/svg/push.svg",
	"./question.svg": "./src/icons/svg/question.svg",
	"./remark.svg": "./src/icons/svg/remark.svg",
	"./ship.svg": "./src/icons/svg/ship.svg",
	"./statistics.svg": "./src/icons/svg/statistics.svg",
	"./supply.svg": "./src/icons/svg/supply.svg",
	"./system.svg": "./src/icons/svg/system.svg",
	"./three.svg": "./src/icons/svg/three.svg",
	"./tip-detail.svg": "./src/icons/svg/tip-detail.svg",
	"./todone.svg": "./src/icons/svg/todone.svg",
	"./two.svg": "./src/icons/svg/two.svg",
	"./updateLog.svg": "./src/icons/svg/updateLog.svg",
	"./upload.svg": "./src/icons/svg/upload.svg",
	"./upload2.svg": "./src/icons/svg/upload2.svg",
	"./warning.svg": "./src/icons/svg/warning.svg",
	"./work.svg": "./src/icons/svg/work.svg",
	"./xlsx.svg": "./src/icons/svg/xlsx.svg",
	"./zgyh.svg": "./src/icons/svg/zgyh.svg",
	"./zhuanjiao.svg": "./src/icons/svg/zhuanjiao.svg",
	"./zsyh.svg": "./src/icons/svg/zsyh.svg",
	"./zxyh.svg": "./src/icons/svg/zxyh.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";